import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';

var ModalFooter = function ModalFooter(_ref) {
  var className = _ref.className,
      pos = _ref.pos,
      noBorder = _ref.noBorder,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('jmtd-modal-footer', className, "jmtd-modal-operate-".concat(pos), {
      'jmtd-modal-no-border': noBorder
    })
  }, children);
};

ModalFooter.propTypes = {
  className: PropTypes.string,
  pos: PropTypes.oneOf(['left', 'right', 'center']),
  noBorder: PropTypes.bool,
  children: PropTypes.node
};
ModalFooter.defaultProps = {
  className: '',
  pos: 'right',
  noBorder: false,
  children: null
};
export default ModalFooter;